import requestedServices from './requestedServices'
import services from './services'

export default { requestedServices, services }
